import React, { useState } from 'react';
import { NJButton, NJModal,NJModalContent } from '@engie-group/fluid-design-system-react';


import './RefinePopup.css'


function RefinePopup({ isOpen, handleClose, handleValidate }) {

    const [request, setRequest] = useState('');


    const validate = (e) => {
        handleValidate(request);
    }

    return (
        <NJModal
            id="modalRework"
            isOpen={isOpen}
            className="refine-popup-modal"
        >
            <NJModalContent
                footer={
                    <>
                        <NJButton
                            emphasis="bold"
                            variant="secondary"
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <NJButton
                            label="Rework the Ad"
                            variant="ai"
                            icon="engie_ai"
                            disabled={!request}
                            onClick={validate}                           
                        />
                    </>
                }
                icon="engie_ai"
                id="modalRework"
                onClose={handleClose}
                title="Rework the Ad"
            >
                <textarea
                    spellCheck="false"
                    className={`refine-popup-request `}
                    value={request}
                    onChange={(e) => setRequest(e.target.value)}
                    placeholder='Please describe the changes you want to make'
                    rows="2"

                />
            </NJModalContent>
        </NJModal>       
    )
}

export default RefinePopup;
